import { render, staticRenderFns } from "./JQM.vue?vue&type=template&id=39f1cb74&scoped=true&"
import script from "./JQM.vue?vue&type=script&lang=js&"
export * from "./JQM.vue?vue&type=script&lang=js&"
import style0 from "./JQM.vue?vue&type=style&index=0&id=39f1cb74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f1cb74",
  null
  
)

export default component.exports